var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('GChart',{attrs:{"type":"GeoChart","data":_vm.dataTable,"options":_vm.options,"settings":{ packages: ['geochart'] }}}):_c('b-skeleton-img')}
var staticRenderFns = []

export { render, staticRenderFns }